import React from 'react';
import { X, ShieldOff, Swords } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function SolutionSection() {
  const solutions = [{
    icon: <X className="w-10 h-10" data-id="element-124" />,
    title: 'Ignoralo',
    description: 'Te dijeron que lo ignore. Pero ignorar no frena al agresor. Le da más poder porque ve que nadie reacciona y siente que tiene vía libre para seguir lastimando.'
  }, {
    icon: <ShieldOff className="w-10 h-10" data-id="element-125" />,
    title: 'Hablá con la Directora',
    description: 'Fuiste al colegio. Te dijeron que "son cosas de chicos" o que "ya lo van a solucionar". Mientras tanto, tu hijo sigue sufriendo todos los días esperando una ayuda que no llega.'
  }, {
    icon: <Swords className="w-10 h-10" data-id="element-126" />,
    title: 'Enseñale a pelear',
    description: 'Responder con violencia solo empeora las cosas, lo pone en riesgo físico, lo expone a sanciones del colegio y le da al agresor exactamente la reacción descontrolada que busca.'
  }];
  return <section className="w-full py-24 px-6 bg-creme" data-id="element-127">
      <div className="max-w-6xl mx-auto" data-id="element-128">
        <FadeIn data-id="element-129">
          <div className="text-center mb-20" data-id="element-130">
            <h2 className="font-playfair text-4xl md:text-5xl text-dark-coffee font-semibold mb-6" data-id="element-131">
              Lo que te dijeron que funciona...{' '}
              <span className="italic text-warm-accent block mt-2" data-id="element-132">
                no funciona.
              </span>
            </h2>
            <p className="text-soft-brown text-lg max-w-2xl mx-auto" data-id="element-133">
              Las soluciones tradicionales fallan porque no entienden la
              psicología del acoso escolar en Argentina.
            </p>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-134">
          {solutions.map((item, index) => <FadeIn key={index} delay={index * 0.2} data-id="element-135">
              <div className="bg-white rounded-3xl p-10 flex flex-col items-center text-center h-full border border-beige shadow-soft transition-all hover:-translate-y-2 hover:shadow-xl group" data-id="element-136">
                <div className="w-20 h-20 rounded-full bg-red-50 flex items-center justify-center text-red-800 mb-8 group-hover:scale-110 transition-transform duration-300" data-id="element-137">
                  {item.icon}
                </div>
                <h3 className="font-playfair text-2xl font-bold text-dark-coffee mb-4" data-id="element-138">
                  {item.title}
                </h3>
                <p className="text-soft-brown leading-relaxed text-lg" data-id="element-139">
                  {item.description}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}